let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_BUDGETHEAD": "Create Budget Head",
    "LBL_VIEW_BUDGETHEAD": "View Budget Head",
    "LBL_BUDGETHEAD_NAME": "Name",
    "LBL_BRANCH": "Branch",
    "LBL_EMAIL": "Email",
    "LBL_PHONE":"Phone",
    "LBL_GENDER":"Gender",
    "LBL_IMAGE":"Image",
    "LBL_DOB":"DOB",
    "LBL_STATUS":"Status",
    "LBL_HOBBIES":"Hobbies",
    "LBL_SINGING":"Singing",
    "LBL_DANCE":"Dancing",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_BUDGETHEAD_SEQUENCE":"Head Sequence",
    "LBL_IS_MONTHLY":"Is Monthly",
}

export default language;